export const dataText = {
  en: {
    title: 'ATTENTION',
    text: 'You must accept the terms and conditions',
    buttonTitle: "CLOSE"
  },
  es: {
    title: 'ATENCION',
    text: 'Debe aceptar los términos y condiciones',
    buttonTitle: "CERRAR"
  },
  pt: {
    title: 'ATENÇÃO',
    text: 'Deve aceitar os termos e condições',
    buttonTitle: "FECHAR"
  }
}
